<template>
    <div class="fieldset">
        <text-headline-secondary>
            {{ title }}
        </text-headline-secondary>

        <p>
            {{ description }}
        </p>

        <div class="row">
            <div class="field">
                <field-customer-name :validate="validate" />
            </div>
        </div>

        <div class="row">
            <div class="field">
                <field-customer-email :validate="validate" />
            </div>

            <div class="field">
                <field-customer-email-confirm :validate="validate" />
            </div>
        </div>
    </div>
</template>

<script>
import FieldCustomerName from "@/components/fields/FieldCustomerName";
import FieldCustomerEmail from "@/components/fields/FieldCustomerEmail";
import FieldCustomerEmailConfirm from "@/components/fields/FieldCustomerEmailConfirm";

export default {
    name: "FieldsetCustomerContact",
    components: {
        FieldCustomerName,
        FieldCustomerEmail,
        FieldCustomerEmailConfirm
    },
    props: {
        validate: { type: Boolean, default: false },
        title: { type: String, required: true },
        description: { type: String, required: true }
    }
};
</script>

<style scoped lang="scss">
.field {
    margin-bottom: 1rem;
}

@media (min-width: $breakpoint-tablet) {
    .row {
        display: flex;
    }

    .field {
        margin-bottom: 1.5rem;
    }

    .row .field {
        flex: 1 1 0px;
    }

    .row .field + .field {
        margin-left: 1.5rem;
    }
}
</style>
